module.exports = __webpack_public_path__ + "static/media/Our Company - Top Banner - BTD - mobile.97bceac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies-details/Our Company - Top Banner - BTD - mobile.png
// module id = 357
// module chunks = 0